module.exports = __webpack_public_path__ + "static/media/220.fe831d06.svg";